import { render, staticRenderFns } from "./ContentsForm.vue?vue&type=template&id=68c3d530&scoped=true&"
import script from "./ContentsForm.vue?vue&type=script&lang=js&"
export * from "./ContentsForm.vue?vue&type=script&lang=js&"
import style0 from "./ContentsForm.vue?vue&type=style&index=0&id=68c3d530&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c3d530",
  null
  
)

export default component.exports